import { DateTime } from 'luxon';

export const convertUnixTimestampToDate = timestamp => {
    return DateTime.fromSeconds(timestamp).toFormat('dd/LL/yyyy');
};

export const removeTHFromString = date => {
    return date
        .split(' ')
        .map((d, i) => (i === 1 ? d.replace(/st|nd|rd|th/g, '') : d))
        .join(' ');
};

export const addTHIntoString = date => {
    const addTh = num => {
        switch (num % 10) {
            case 1:
                return num % 100 === 11 ? 'th' : 'st';
            case 2:
                return num % 100 === 12 ? 'th' : 'nd';
            case 3:
                return num % 100 === 13 ? 'th' : 'rd';
            default:
                return 'th';
        }
    };
    return date
        .split(' ')
        .map((d, i) => (i === 1 ? `${d}${addTh(d)}` : d))
        .join(' ');
};

export const getLastActivityDate = user => {
    const dates = [
        user?.last_login,
        user?.lastActivity,
        user?.contract_signed,
        user?.navStepTime,
    ].filter(Boolean);
    if (dates.length === 0) return 'N/A';
    const most_recent = dates.reduce((a, b) =>
        DateTime.fromISO(a) > DateTime.fromISO(b) ? a : b,
    );
    return DateTime.fromISO(most_recent).toFormat('dd LLL, y t');
};

export const getTimeZone = province => {
    let timezone = 'America/Toronto';
    if (province == 'Ontario' || province == 'Quebec' || province == 'Québec') {
        timezone = 'America/Toronto';
    } else if (province == 'British_Columbia') {
        timezone = 'America/Vancouver';
    } else if (province == 'New_York') {
        timezone = 'America/New_York';
    } else if (province == 'Texas') {
        timezone = 'America/Chicago';
    } else if (province == 'Alberta') {
        timezone = 'America/Edmonton';
    } else if (province == 'Saskatchewan') {
        timezone = 'America/Regina';
    } else if (province == 'Manitoba') {
        timezone = 'America/Winnipeg';
    } else if (province == 'Nova_Scotia') {
        timezone = 'America/Halifax';
    }
    return timezone;
};
